import {cloneDeep} from 'lodash';
import {createImageObject} from '../utils';
import {
    placeHolder,
    designFormConfig,
    intelFormConfig,
    defaultIntelFormData,
    defaultDesignFormData
} from '@/views/V2/image/coverPicture/utils';

export default {
    namespaced: true,
    state: {
        displayImg: [],
        placeHolder,
        designFormConfig: cloneDeep(designFormConfig),
        intelFormConfig: cloneDeep(intelFormConfig),
        intelFormData: cloneDeep(defaultIntelFormData),
        designFormData: cloneDeep(defaultDesignFormData),
        toolBarLoading: false,
        intelFormCanSubmit: [{}],
        designFormCanSubmit: [{}],
        intelFormExt: {},
        canSubmit: false,
        pageLoadingStatus: {
            show: false,
            title: ''
        }
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_MULTIPLE_STATES(state, updates) {
            for (let update of updates) {
                state[update.key] = update.value;
            }
        },
        UPDATE_FORM_DATA(state, {form, key, value}) {
            state[form] = {...state[form], [key]: value};
        }
    },
    actions: {
        updateFormData({commit}, data) {
            const {form, key, value} = data;
            commit('UPDATE_FORM_DATA', {
                form,
                key,
                value
            });
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        updateMultipleState({commit}, data) {
            commit('UPDATE_MULTIPLE_STATES', data);
        },
         handleDesignFormSubmit({commit}, {data}) {
            const displayImg = data.map(item => createImageObject({
                ...item
            }));
            commit('UPDATE_MULTIPLE_STATES', [
                // 更新展示区图片
                {
                    key: 'displayImg',
                    value: displayImg
                }
            ]);
        },
        changeLoadingStatus({commit}, {targetCount, ratioNum = 1}) {
            commit('UPDATE_COMMON_STATE', {
                key: 'toolBarLoading',
                value: true
            });
            // loading态，且有骨架屏数量，则生成骨架屏的结果区占位数据
            if (typeof targetCount === 'number') {
                const baseDisplayImg = Array.from({
                    length: targetCount
                }, (_, i) => createImageObject({
                    ratioNum: ratioNum,
                    recordId: i
                }));
                commit('UPDATE_COMMON_STATE', {
                    key: 'displayImg',
                    value: baseDisplayImg
                });
            }
        },
        resetFromData({commit}) {
            commit('UPDATE_MULTIPLE_STATES', [
                {
                    key: 'designFormConfig',
                    value: cloneDeep(designFormConfig)
                },
                {
                    key: 'intelFormConfig',
                    value: cloneDeep(intelFormConfig)
                },
                {
                    key: 'intelFormData',
                    value: cloneDeep(defaultIntelFormData)
                },
                {
                    key: 'designFormData',
                    value: cloneDeep(defaultDesignFormData)
                },
                {
                    key: 'canSubmit',
                    value: false
                },
                {
                    key: 'intelFormCanSubmit',
                    value: [{}]
                },
                {
                    key: 'designFormCanSubmit',
                    value: [{}]
                }
            ]);
        }
    },
    getters: {
        formExt: state => {
            const {intelFormData} = state;
            const {coverPicture: {videoValue, type}} = intelFormData;
            let mainTextSug = null;
            let descTextSug = null;
            if (type === 'video') {
                mainTextSug = videoValue.mainTextSug;
                descTextSug = videoValue.descTextSug;
            } else {
                mainTextSug = null;
                descTextSug = null;
            }

            return {
                mainTextSug,
                descTextSug
            };
        }
    }
};